/* ALLÉGA — premium interactions (no dependencies) */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('ap-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }
  function once(el, key) { if (el['_ap_' + key]) return false; el['_ap_' + key] = 1; return true; }

  /* ---------- money ---------- */
  var MONEY_FMT = (window.apMoneyFormat || '{{amount_with_comma_separator}} €');
  function fmtNum(cents, dec, th, dp) {
    var n = (Math.round(cents) / 100).toFixed(dec);
    var p = n.split('.');
    p[0] = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
    return p[1] ? p[0] + dp + p[1] : p[0];
  }
  function money(cents) {
    return MONEY_FMT.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        default: return fmtNum(cents, 2, ' ', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  window.apMoney = money;

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    var els = $$('.ap-rv:not(.is-in)', scope);
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header ---------- */
  function initHeader(scope) {
    $$('[data-ap-header]', scope).forEach(function (hd) {
      if (!once(hd, 'hd')) return;
      var sec = hd.closest('.shopify-section');
      if (sec) sec.classList.add('ap-sticky-sec');
      var onScroll = function () { hd.classList.toggle('is-scrolled', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      var h = hd.getBoundingClientRect().height;
      if (h) root.style.setProperty('--ap-hd-h', Math.round(h) + 'px');
    });
    $$('[data-ap-menu]', scope).forEach(function (menu) {
      if (!once(menu, 'menu')) return;
      var btns = $$('[aria-controls="' + menu.id + '"]');
      var last;
      function open() {
        last = d.activeElement;
        menu.hidden = false;
        requestAnimationFrame(function () { menu.classList.add('is-open'); });
        root.classList.add('ap-lock');
        btns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
        var f = $('a,button', menu.querySelector('.ap-menu__panel')); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 60);
      }
      function close() {
        menu.classList.remove('is-open');
        root.classList.remove('ap-lock');
        btns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        setTimeout(function () { if (!menu.classList.contains('is-open')) menu.hidden = true; }, 500);
        if (last && last.focus) { try { last.focus({ preventScroll: true }); } catch (e) { last.focus(); } }
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { menu.classList.contains('is-open') ? close() : open(); }); });
      $$('[data-ap-close]', menu).forEach(function (c) { c.addEventListener('click', close); });
      $$('.ap-menu__links a', menu).forEach(function (a) { a.addEventListener('click', close); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.classList.contains('is-open')) close(); });
      window.addEventListener('resize', function () { if (window.innerWidth > 989 && menu.classList.contains('is-open')) close(); });
    });
  }

  /* ---------- before / after ---------- */
  function initCompare(scope) {
    $$('[data-ap-ba]', scope).forEach(function (ba) {
      if (!once(ba, 'ba')) return;
      var handle = $('.ap-ba__handle', ba);
      var pos = parseFloat(ba.getAttribute('data-start')) || 50;
      var dragging = false, startX = 0, startY = 0, decided = false, horizontal = false;
      function set(p) {
        pos = Math.max(0, Math.min(100, p));
        ba.style.setProperty('--pos', pos + '%');
        if (handle) handle.setAttribute('aria-valuenow', Math.round(pos));
        var lb = $('.ap-ba__lbl--b', ba), la = $('.ap-ba__lbl--a', ba);
        if (lb) lb.style.opacity = pos < 12 ? 0 : 1;
        if (la) la.style.opacity = pos > 88 ? 0 : 1;
      }
      function fromEvent(x) { var r = ba.getBoundingClientRect(); return ((x - r.left) / r.width) * 100; }
      set(pos);
      ba.addEventListener('pointerdown', function (e) {
        if (e.button !== undefined && e.button !== 0) return;
        dragging = true; decided = e.pointerType === 'mouse'; horizontal = decided;
        startX = e.clientX; startY = e.clientY;
        ba.classList.remove('is-anim');
        if (e.pointerType === 'mouse') { ba.classList.add('is-drag'); set(fromEvent(e.clientX)); e.preventDefault(); }
        try { ba.setPointerCapture(e.pointerId); } catch (err) {}
      });
      ba.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 4 && dy < 4) return;
          decided = true; horizontal = dx >= dy;
          if (!horizontal) { dragging = false; return; }
          ba.classList.add('is-drag');
        }
        if (horizontal) { set(fromEvent(e.clientX)); }
      });
      function end(e) {
        if (!dragging) return;
        if (!decided && e && e.type === 'pointerup') { ba.classList.add('is-anim'); set(fromEvent(e.clientX)); }
        dragging = false; ba.classList.remove('is-drag');
      }
      ba.addEventListener('pointerup', end);
      ba.addEventListener('pointercancel', end);
      ba.addEventListener('lostpointercapture', function () { dragging = false; ba.classList.remove('is-drag'); });
      if (handle) handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { set(pos - step); e.preventDefault(); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { set(pos + step); e.preventDefault(); }
        else if (e.key === 'Home') { set(0); e.preventDefault(); }
        else if (e.key === 'End') { set(100); e.preventDefault(); }
      });
      ba.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(scope) {
    $$('[data-ap-gal]', scope).forEach(function (g) {
      if (!once(g, 'gal')) return;
      var track = $('.ap-gal__track', g), slides = $$('.ap-gal__slide', g), thumbs = $$('.ap-gal__th', g);
      var prev = $('.ap-gal__nav--p', g), next = $('.ap-gal__nav--n', g), count = $('.ap-gal__count', g);
      var idx = 0, t;
      function mark(i) {
        idx = i;
        thumbs.forEach(function (th, k) { th.classList.toggle('is-on', k === i); th.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        var th = thumbs[i];
        if (th && th.parentNode.scrollWidth > th.parentNode.clientWidth) {
          var p = th.parentNode; p.scrollTo({ left: th.offsetLeft - p.clientWidth / 2 + th.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      }
      g.apGo = go;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== idx) mark(i);
        }, 60);
      }, { passive: true });
      thumbs.forEach(function (th, k) { th.addEventListener('click', function () { go(k); }); });
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      g.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(idx - 1);
        if (e.key === 'ArrowRight') go(idx + 1);
      });
      mark(0);
    });
  }

  /* ---------- cart ---------- */
  function refreshCart(json) {
    var drawer = d.querySelector('cart-drawer');
    if (json && json.sections && drawer && typeof drawer.renderContents === 'function' && json.sections['cart-drawer']) {
      try { drawer.renderContents(json); return 'drawer'; } catch (e) {}
    }
    if (json && json.sections && json.sections['cart-icon-bubble']) {
      var bubble = d.getElementById('cart-icon-bubble');
      if (bubble) {
        var doc = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html');
        var inner = doc.querySelector('.shopify-section');
        if (inner) bubble.innerHTML = inner.innerHTML;
      }
      return 'bubble';
    }
    return 'none';
  }

  function addToCart(item, extra) {
    var body = { items: [item].concat(extra || []), sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) { var err = new Error(j.description || j.message || 'Erreur'); err.data = j; throw err; }
        return j;
      });
    });
  }

  /* ---------- pack selection (works even if product data is unavailable) ---------- */
  d.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || t.name !== 'id' || !t.closest('.ap-packs')) return;
    $$('.ap-pack', t.closest('.ap-packs')).forEach(function (c) { var i = $('input', c); c.classList.toggle('is-on', !!(i && i.checked)); });
  });

  /* ---------- buy box ---------- */
  function initBuy(scope) {
    $$('[data-ap-buy]', scope).forEach(function (box) {
      if (!once(box, 'buy')) return;
      var dataEl = $('script[data-ap-product]', box);
      var product = null; try { product = JSON.parse(dataEl.textContent); } catch (e) { product = null; }
      if (!product || !product.variants || !product.variants.length) {
        product = { variants: $$('.ap-pack', box).map(function (l) {
          return { id: parseInt(l.getAttribute('data-vid'), 10), title: l.getAttribute('data-title') || '', price: parseInt(l.getAttribute('data-price'), 10) || 0,
            compare_at_price: parseInt(l.getAttribute('data-cmp'), 10) || 0, available: l.getAttribute('data-avail') !== 'false', selling_plan_allocations: [] };
        }) };
        if (!product.variants.length) return;
      }
      var form = $('form[data-ap-form]', box);
      function idInputEl() { return $('input[name="id"]:checked', form) || $('input[name="id"]', form); }
      var spInput = $('input[name="selling_plan"]', form);
      var atcs = $$('[data-ap-atc]', d).filter(function (b) { return b.getAttribute('data-ap-atc') === box.id; });
      var err = $('.ap-err', box);
      var planSel = $('select[data-ap-plan]', box);
      var base1 = product.variants[0];
      function variant() { var el = idInputEl(); var id = el ? parseInt(el.value, 10) : 0; for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(id)) return product.variants[i]; return product.variants[0]; }
      function mode() { var m = $('input[name="ap-mode-' + box.id + '"]:checked', box); return m ? m.value : 'once'; }
      function planId() { return planSel ? parseInt(planSel.value, 10) : (spInput && spInput.getAttribute('data-default') ? parseInt(spInput.getAttribute('data-default'), 10) : null); }
      function alloc(v, pid) {
        var a = v.selling_plan_allocations || [];
        for (var i = 0; i < a.length; i++) if (a[i].selling_plan_id === pid) return a[i];
        return null;
      }
      function qty(v) { var n = parseInt((v.title || '').replace(/[^0-9]/g, ''), 10); return n > 0 ? n : 1; }
      function setText(sel, txt) { $$(sel, box).forEach(function (e) { e.textContent = txt; }); }

      function update() {
        var v = variant(), m = mode(), pid = planId(), n = qty(v);
        var price = v.price, compare = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : 0;
        var ref = compare || (base1 ? base1.price * n : 0);
        if (m === 'sub' && pid) { var a = alloc(v, pid); if (a) { price = a.price; } }
        if (spInput) {
          if (m === 'sub' && pid) { spInput.value = pid; spInput.disabled = false; } else { spInput.value = ''; spInput.disabled = true; }
        }
        var save = ref > price ? ref - price : 0;
        setText('[data-ap-price]', money(price));
        $$('[data-ap-was]', box).forEach(function (e) { e.textContent = save ? money(ref) : ''; e.hidden = !save; });
        $$('[data-ap-save]', box).forEach(function (e) { e.textContent = save ? 'Économie ' + money(save) + (e.getAttribute('data-sfx') || '') : ''; e.hidden = !save; });
        $$('[data-ap-unit]', box).forEach(function (e) { e.textContent = n > 1 ? 'Soit ' + money(Math.round(price / n)) + ' ' + (e.getAttribute('data-unit') || 'le flacon') : ''; e.hidden = n <= 1; });
        // mode card prices
        var onceP = $('[data-ap-once-price]', box); if (onceP) onceP.textContent = money(v.price);
        var subP = $('[data-ap-sub-price]', box);
        if (subP && pid) { var a2 = alloc(v, pid); subP.textContent = a2 ? money(a2.price) : money(v.price); var subW = $('[data-ap-sub-was]', box); if (subW) subW.textContent = a2 && a2.price < v.price ? money(v.price) : ''; }
        // pack cards (subscription price when relevant)
        $$('.ap-pack', box).forEach(function (card) {
          var inp = $('input', card), vid = parseInt(inp.value, 10), cv = null;
          card.classList.toggle('is-on', inp.checked);
          for (var i = 0; i < product.variants.length; i++) if (String(product.variants[i].id) === String(inp.value)) cv = product.variants[i];
          if (!cv) return;
          var cp = cv.price; if (m === 'sub' && pid) { var a3 = alloc(cv, pid); if (a3) cp = a3.price; }
          var cn = qty(cv), cref = (cv.compare_at_price && cv.compare_at_price > cv.price) ? cv.compare_at_price : (base1 ? base1.price * cn : 0), csave = cref > cp ? cref - cp : 0;
          var now = $('.ap-pack__now', card); if (now) now.textContent = money(cp);
          var was = $('[data-ap-pwas]', card); if (was) { was.textContent = money(cref); was.hidden = !csave; }
          var pu = $('[data-ap-punit]', card); if (pu) pu.textContent = money(Math.round(cp / cn));
          var ps = $('[data-ap-psave]', card), psw = $('[data-ap-psave-w]', card);
          if (ps) ps.textContent = 'Économie ' + money(csave) + (ps.getAttribute('data-sfx') || '');
          if (psw) psw.hidden = !csave;
        });
        $$('.ap-mode', box).forEach(function (c) { var i = $('input', c); c.classList.toggle('is-on', i && i.checked); });
        // stock + availability
        var st = $('.ap-stock', box);
        if (st) { st.classList.toggle('is-out', !v.available); var stt = $('[data-ap-stock-t]', st); if (stt) stt.textContent = v.available ? (st.getAttribute('data-in') || 'En stock') : (st.getAttribute('data-out') || 'Épuisé'); }
        atcs.forEach(function (b) {
          b.disabled = !v.available;
          var l = $('[data-ap-atc-label]', b); if (l) l.textContent = v.available ? (b.getAttribute('data-label') || 'Ajouter au panier') : 'Épuisé';
        });
        // sticky bar variant label
        setText('[data-ap-vtitle-' + box.id + ']', v.title);
        $$('[data-ap-sprice-' + box.id + ']').forEach(function (e) { e.textContent = money(price); });
        if (err) err.classList.remove('is-on');
      }

      $$('.ap-pack input', box).forEach(function (inp) {
        inp.addEventListener('change', update);
      });
      $$('input[name="ap-mode-' + box.id + '"]', box).forEach(function (inp) { inp.addEventListener('change', update); });
      if (planSel) planSel.addEventListener('change', update);

      var busy = false;
      function submit() {
        if (busy) return;
        var v = variant(); if (!v.available) return;
        busy = true;
        if (err) err.classList.remove('is-on');
        atcs.forEach(function (b) { b.classList.remove('is-added'); b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
        var item = { id: v.id, quantity: 1 };
        if (spInput && !spInput.disabled && spInput.value) item.selling_plan = parseInt(spInput.value, 10);
        var chk = $('.ap-pack input:checked', box); var lab = chk ? chk.closest('.ap-pack') : null;
        var bonusId = lab ? lab.getAttribute('data-bonus') : null, bonusH = lab ? lab.getAttribute('data-bonus-h') : null;
        var getBonus = bonusId ? Promise.resolve(parseInt(bonusId, 10)) : (bonusH ? fetch('/products/' + bonusH + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (pj) { return pj && pj.variants && pj.variants[0] ? pj.variants[0].id : null; }).catch(function () { return null; }) : Promise.resolve(null));
        getBonus.then(function (bid) {
          var extra = bid ? [{ id: bid, quantity: 1 }] : [];
          return addToCart(item, extra).catch(function (e) { if (extra.length) return addToCart(item, []); throw e; });
        }).then(function (json) {
          atcs.forEach(function (b) { b.classList.remove('is-loading'); b.classList.add('is-added'); b.removeAttribute('aria-busy'); });
          var live = $('[data-ap-live]', box); if (live) live.textContent = 'Produit ajouté au panier';
          var how = refreshCart(json);
          d.dispatchEvent(new CustomEvent('ap:cart:added', { detail: json }));
          setTimeout(function () { atcs.forEach(function (b) { b.classList.remove('is-added'); }); busy = false; }, 2200);
          if (how === 'none') { setTimeout(function () { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }, 700); }
        }).catch(function (e) {
          atcs.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
          busy = false;
          if (err) { err.textContent = (e && e.message && e.message !== 'Failed to fetch') ? e.message : 'Une erreur est survenue. Réessaie dans un instant.'; err.classList.add('is-on'); }
        });
      }
      if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
      atcs.forEach(function (b) { if (!form || !form.contains(b)) b.addEventListener('click', function (e) { e.preventDefault(); submit(); }); });
      box.apSubmit = submit;
      update();
    });
  }

  /* ---------- sticky add-to-cart bar ---------- */
  function initSticky(scope) {
    $$('[data-ap-sbar]', scope).forEach(function (bar) {
      if (!once(bar, 'sbar')) return;
      var target = d.getElementById(bar.getAttribute('data-ap-sbar'));
      if (!target || !('IntersectionObserver' in window)) return;
      var cta = $('.ap-atc', target) || target;
      var footer = d.querySelector('.ap-ft') || d.querySelector('footer');
      var ctaState = 'visible', footVis = false;
      function render() {
        var show = ctaState === 'above' && !footVis;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        $$('a,button,select,input', bar).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
        d.body.classList.toggle('ap-has-sbar', show && window.innerWidth < 990);
      }
      new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) ctaState = 'visible';
          else ctaState = e.boundingClientRect.top < 0 ? 'above' : 'below';
        });
        render();
      }, { threshold: 0 }).observe(cta);
      if (footer) new IntersectionObserver(function (en) { en.forEach(function (e) { footVis = e.isIntersecting; }); render(); }, { threshold: 0 }).observe(footer);
      window.addEventListener('resize', render);
      render();
    });
  }

  /* ---------- reviews "voir plus" ---------- */
  function initReviews(scope) {
    $$('[data-ap-more]', scope).forEach(function (btn) {
      if (!once(btn, 'more')) return;
      var list = d.getElementById(btn.getAttribute('data-ap-more'));
      if (!list) return;
      var step = parseInt(btn.getAttribute('data-step'), 10) || 3;
      btn.addEventListener('click', function () {
        var hidden = $$('.ap-rev[hidden]', list);
        hidden.slice(0, step).forEach(function (r) { r.hidden = false; r.classList.add('ap-rv'); requestAnimationFrame(function () { r.classList.add('is-in'); }); });
        if ($$('.ap-rev[hidden]', list).length === 0) btn.parentNode.hidden = true;
      });
    });
  }

  /* ---------- smooth accordions ---------- */
  function initAccordions(scope) {
    $$('details[data-ap-acc]', scope).forEach(function (det) {
      if (!once(det, 'acc')) return;
      var sum = $('summary', det), body = sum && sum.nextElementSibling;
      if (!sum || !body || reduce || !body.animate) return;
      var anim = null;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        if (anim) anim.cancel();
        if (det.open) {
          var h = body.offsetHeight;
          anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 320, easing: 'cubic-bezier(.22,.7,.2,1)' });
          anim.onfinish = function () { det.open = false; anim = null; };
        } else {
          det.open = true;
          var h2 = body.offsetHeight;
          anim = body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 380, easing: 'cubic-bezier(.22,.7,.2,1)' });
          anim.onfinish = function () { anim = null; };
        }
      });
    });
  }

  /* ---------- plantes : cercles interactifs ---------- */
  function initPlants(scope) {
    $$('[data-ap-plants]', scope).forEach(function (row) {
      if (!once(row, 'plants')) return;
      var items = $$('.ap-pl__it', row);
      items.forEach(function (it) {
        var btn = $('.ap-pl__c', it);
        btn.addEventListener('click', function () {
          var open = !it.classList.contains('is-open');
          it.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        btn.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && it.classList.contains('is-open')) { btn.click(); }
        });
      });
      if (items.length > 1) {
        var dots = d.createElement('div');
        dots.className = 'ap-pl__dots'; dots.setAttribute('aria-hidden', 'true');
        items.forEach(function () { dots.appendChild(d.createElement('span')); });
        row.parentNode.insertBefore(dots, row.nextSibling);
        var spans = $$('span', dots);
        var upd = function () {
          var c = row.scrollLeft + row.clientWidth / 2, best = 0, bd = 1e9;
          items.forEach(function (it, i) { var m = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(m - c); if (dd < bd) { bd = dd; best = i; } });
          spans.forEach(function (s, i) { s.classList.toggle('on', i === best); });
        };
        row.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
        upd();
      }
    });
  }

  /* ---------- offre limitée : compte à rebours réel (ne redémarre jamais) ---------- */
  function initPromo(scope) {
    $$('[data-ap-promo]', scope).forEach(function (bar) {
      if (!once(bar, 'promo')) return;
      var end = parseInt(bar.getAttribute('data-ap-promo'), 10) * 1000;
      var cd = $('.ap-ann__cd', bar), els = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { els[k] = $('[data-u="' + k + '"]', bar); });
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var t;
      var tick = function () {
        var left = Math.floor((end - Date.now()) / 1000);
        if (left <= 0) {
          clearInterval(t);
          bar.classList.remove('ap-ann--promo');
          var pr = $('.ap-ann__promo', bar); if (pr) pr.parentNode.removeChild(pr);
          if (!$('.ap-ann__std', bar)) bar.style.display = 'none';
          return;
        }
        var dd = Math.floor(left / 86400), hh = Math.floor(left % 86400 / 3600), mm = Math.floor(left % 3600 / 60), ss = left % 60;
        cd.classList.toggle('has-d', dd > 0);
        els.d.textContent = pad(dd); els.h.textContent = pad(hh); els.m.textContent = pad(mm); els.s.textContent = pad(ss);
      };
      tick(); t = setInterval(tick, 1000);
    });
  }

  /* ---------- avis : points de navigation sur mobile ---------- */
  function initRevDots(scope) {
    $$('.ap-revs', scope).forEach(function (row) {
      if (!once(row, 'revdots')) return;
      var items = $$('.ap-rev', row);
      if (items.length < 2) return;
      var dots = d.createElement('div'); dots.className = 'ap-revs__dots'; dots.setAttribute('aria-hidden', 'true');
      items.forEach(function () { dots.appendChild(d.createElement('span')); });
      row.parentNode.insertBefore(dots, row.nextSibling);
      var spans = $$('span', dots);
      var upd = function () {
        var c = row.scrollLeft + row.clientWidth / 2, best = 0, bd = 1e9;
        items.forEach(function (it, i) { var m = it.offsetLeft + it.offsetWidth / 2, dd = Math.abs(m - c); if (dd < bd) { bd = dd; best = i; } });
        spans.forEach(function (s, i) { s.classList.toggle('on', i === best); });
      };
      row.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
      upd();
    });
  }

  function init(scope) {
    try { initHeader(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initReveal(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initCompare(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initGallery(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initBuy(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initSticky(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initReviews(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initAccordions(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initPlants(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initPromo(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
    try { initRevDots(scope); } catch (e) { if (window.console) console.error('[allega]', e); }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); }); else init(d);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
